module.exports = __webpack_public_path__ + "img/CP.38befd8d.png";